export const projects = [
  {
    title: "E-Commerce Backend Microservices",
    subtitle: "Spring boot, Java, Gradle, PostgreSQL, CloudGateway, GraphQL, Eureka, Kafka, Netflix DGS, Netty",
    description:
      `Created for my medium blog series. Scalable backend micro services. Eureka is used for service registry
      Cloud gateway is used for API gateway. Kafka is used to send product data to order service.

      `,
    image: "./ecombackend.gif",
    link: "https://github.com/deBilla/e-commerce-ws",
  },
  {
    title: "Serendib Scholarship Data Store",
    subtitle: "React, Typescript, AWS SAM, NodeJS, GCP",
    description:
      "This project was done for a non profit organization called serendib trust. I have added all the details of the implementation in medium articles. Backend done different ways.",
    image: "./serendib.gif",
    link: "https://github.com/deBilla/serendib-scholarship-ui",
  },
  {
    title: "Stock Market Watch List",
    subtitle: "Flutter, Dart, Spring boot, Java, Kafka, Yahoo API",
    description:
      "This was my first pet project for my medium blog. I needed to learn Flutter, so did this and taught others along the way but what I really learned was Spring boot.",
    image: "./stockwatchlist.webp",
    link: "https://github.com/deBilla/yahoo-stock-backend",
  }
];

export const testimonials = [
  {
    quote:
      `"Dimuthu worked in a team reporting to me for about 1.5 years. During that time 
      he displayed some very impressive characteristics. Dimuthu is a fast learner and he is always willing to 
      take on new challenges. He was the owner of two of the applications within the team. He directly worked with on-shore 
      stakeholders and delivered the requirements on time and at the quality level expected. 
      He only required minimal oversight during this time period. Dimuthu will be a great addition to any team."`,
    image: "https://media.licdn.com/dms/image/C5603AQEYAWY36IkRZg/profile-displayphoto-shrink_100_100/0/1613652086763?e=1687392000&v=beta&t=4QP9oYHPEN1FQ4du4riY552WCb06OgdojnZQbhhmYUA",
    name: "Dishan Metihakwala",
    company: "Sysco",
  },
  {
    quote:
      `"I have worked closely with Dimuthu for over 2 years at Sysco LABS and can say that he is an outstanding engineer 
      who has both engineering and leadership skills. He led a team which is reporting to me and 
      the team was owning a few important applications in the freight management area of the Sysco business. 

      Very conversant in both back-end and front-end technologies and managed to deliver all important releases successfully.
       Dimuthu is a great asset to any organization and has a lot more to contribute to the industry. 
       I would like to wish him the best of luck."`,
    image: "https://media.licdn.com/dms/image/C5603AQHbUjYMTS2i6w/profile-displayphoto-shrink_100_100/0/1630752717210?e=1687392000&v=beta&t=eOPbQTUH0R6CbqzJpePuocCOSVxUm-IvvsiVhJLZJ1A",
    name: "Chinthaka Sandaruwan",
    company: "Sysco",
  },
  {
    quote:
      `"Dimuthu is an exceptional developer who possesses all the skills one would want in an excellent Software Engineer. 
      He has been a great resource to the company and to the clients. He did an incredible job on all the projects, 
      making timely deliveries with accuracy and going the extra mile to ensure the company standards and client requirements are met. 
      Dimuthu is very positive in his attitude and always welcoming to feedback and making improvements, which makes him a continuously 
      improving individual aiming for higher goals in his career. Wishing him a great future and a successful life ahead."`,
    image: "https://media.licdn.com/dms/image/C5603AQHLb6Ao0gIPBw/profile-displayphoto-shrink_100_100/0/1628689181117?e=1687392000&v=beta&t=gRN1xsO6aU36ViPv80Auynhp9km44TLMlkTUUKqWirk",
    name: "Priyabashitha L.P.",
    company: "Directfn",
  }
];

export const skills = [
  "Spring boot",
  "Java",
  "AWS",
  "GCP",
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "GraphQL",
  "REST"
];



// WEBPACK FOOTER //
// ./src/data.js